@if (desktop) {
  <rk-sidenav-action-wrapper
    (cancelled)="cancelEdit()"
    (submitted)="submit()"
    [disabledSubmit]="!trackEditForm || (trackEditForm && trackEditForm.invalid)"
    *ngIf="trackEditForm"
    [title]="modalTitle"
  >
    <ng-container *ngTemplateOutlet="content"> </ng-container>
  </rk-sidenav-action-wrapper>
} @else {
  <div class="pb-16">
    <ng-container *ngTemplateOutlet="content"> </ng-container>
    <rk-footer-actions
      (cancelled)="cancelEdit()"
      (submitted)="submit()"
    ></rk-footer-actions>
  </div>
}

<ng-template #content>
  <form
    (ngSubmit)="submit()"
    [formGroup]="trackEditForm"
    novalidate
    *ngIf="editingTracks$ | async as tracks"
  >
    <div class="root-top md:bg-white">
      <rk-track-image-upload [tracks]="tracks"></rk-track-image-upload>
      <div>
        <rk-form-field
          [label]="'MEDIA.EDIT_TRACK.TITLE' | translate"
          [hideCharLimit]="true"
        >
          <input
            type="text"
            rkInput
            rkAutoFocus
            [autoFocusDelayMs]="autoFocusDelayMs"
            formControlName="title"
            autocomplete="title"
            maxlength="150"
            [placeholder]="
              tracks.length > 1
                ? ('MEDIA.EDIT_TRACK.PLACEHOLDER_LEAVE_EMPTY' | translate)
                : ''
            "
            [required]="tracks.length === 1"
          />
          <rk-form-error
            *ngIf="
              trackEditFormErrors.title.required || trackEditFormErrors.title.pattern
            "
            [errorMessage]="'MEDIA.EDIT_TRACK.TITLE_REQUIRED' | translate"
          ></rk-form-error>
        </rk-form-field>
      </div>
      <div>
        <rk-form-field
          [label]="'MEDIA.EDIT_TRACK.ARTIST' | translate"
          [hideCharLimit]="true"
        >
          <input
            type="text"
            rkInput
            formControlName="artist"
            autocomplete="artist"
            maxlength="150"
            [placeholder]="
              tracks.length > 1
                ? ('MEDIA.EDIT_TRACK.PLACEHOLDER_LEAVE_EMPTY' | translate)
                : ''
            "
          />
        </rk-form-field>
      </div>
      <div class="album-year-section flex flex-col md:flex-row justify-between">
        <rk-form-field
          [label]="'MEDIA.EDIT_TRACK.ALBUM' | translate"
          [hideCharLimit]="true"
        >
          <input
            type="text"
            rkInput
            formControlName="album"
            autocomplete="album"
            maxlength="150"
            [placeholder]="
              tracks.length > 1
                ? ('MEDIA.EDIT_TRACK.PLACEHOLDER_LEAVE_EMPTY' | translate)
                : ''
            "
          />
        </rk-form-field>
        <rk-form-field [label]="'MEDIA.EDIT_TRACK.YEAR' | translate">
          <input
            type="number"
            rkInput
            formControlName="year"
            autocomplete="year"
            min="0"
          />
        </rk-form-field>
      </div>
    </div>

    <div class="gray-part -mt-4 md:mt-0">
      <div class="buy-link-block">
        <rk-form-field [label]="'MEDIA.EDIT_TRACK.BUY_LINK' | translate">
          <input
            type="text"
            rkInput
            formControlName="buyLink"
            [placeholder]="
              tracks.length > 1
                ? ('MEDIA.EDIT_TRACK.PLACEHOLDER_LEAVE_EMPTY' | translate)
                : ''
            "
          />
          <rk-form-error
            *ngIf="trackEditFormErrors.buyLink?.pattern"
            [errorMessage]="'MEDIA.EDIT_TRACK.BUY_LINK_FORMAT' | translate"
          ></rk-form-error>
        </rk-form-field>

        <rk-button
          btnStyle="flat"
          [svgIcon]="'dot-down'"
          [loading]="isSearchingBuyLink$ | async"
          [matMenuTriggerFor]="menuLink"
        ></rk-button>
      </div>
      <rk-chips-input
        *ngIf="!isMultiple"
        label="{{ 'MEDIA.EDIT_TRACK.TAGS' | translate }}"
        formControlName="tags"
        [dataFetched]="tags$ | async"
        [canAddNew]="true"
        [chipMaxLength]="255"
        [placeholder]="'MEDIA.EDIT_TRACK.TAGS_PLACEHOLDER' | translate"
        [isTag]="true"
      ></rk-chips-input>
      <div>
        <rk-form-field [label]="'MEDIA.EDIT_TRACK.BPM' | translate">
          <input
            class="input-bpm"
            type="number"
            rkInput
            formControlName="bpm"
            pKeyFilter="num"
            min="0"
          />
        </rk-form-field>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #loading>
  <div class="loader">
    <rk-loader [isLoading]="true" [size]="33" [center]="true"></rk-loader>
  </div>
</ng-template>

<mat-menu #menuLink="matMenu" [overlapTrigger]="false">
  <ng-container *ngIf="trackEditForm.value['buyLink']">
    <button mat-menu-item (click)="copyLink()">
      <mat-icon fontSet="fa" fontIcon="fa-copy"></mat-icon>
      <span translate>MEDIA.EDIT_TRACK.COPY_LINK</span>
    </button>
    <button mat-menu-item (click)="openLink()">
      <mat-icon fontSet="fa" fontIcon="fa-share"></mat-icon>
      <span translate>MEDIA.EDIT_TRACK.OPEN_LINK</span>
    </button>
    <div class="menu-separator" *ngIf="!isMultiple"></div>
  </ng-container>
  <button mat-menu-item *ngIf="!isMultiple" (click)="findLink()">
    <mat-icon fontSet="fa" fontIcon="fa-link"></mat-icon>
    <span translate>MEDIA.EDIT_TRACK.SEARCH_LINK</span>
  </button>
</mat-menu>
